// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var DomainEdit$ReactHooksTemplate = require("../settings/DomainEdit.res.js");
var DomainList$ReactHooksTemplate = require("./DomainList.res.js");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");
var DomainCreate$ReactHooksTemplate = require("./DomainCreate.res.js");
var Organization$ReactHooksTemplate = require("../settings/organization.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var CurrentOrganization$ReactHooksTemplate = require("../CurrentOrganization.res.js");

var initialState = {
  notification: undefined,
  edited: false,
  domainAddForm: false,
  domainEditForm: undefined,
  loading: false,
  saving: false
};

function DomainManagement(props) {
  var match = React.useContext(CurrentOrganization$ReactHooksTemplate.authContext);
  var setOrganizationProfile = match[1];
  var organizationProfile = match[0];
  var match$1 = React.useState(function (param) {
        return initialState;
      });
  var setState = match$1[1];
  var state = match$1[0];
  var handleAddDomain = function (param) {
    Curry._1(setState, (function (state) {
            return {
                    notification: state.notification,
                    edited: state.edited,
                    domainAddForm: !state.domainAddForm,
                    domainEditForm: state.domainEditForm,
                    loading: state.loading,
                    saving: state.saving
                  };
          }));
  };
  var handleEditDomain = function (domainId) {
    Curry._1(setState, (function (state) {
            return {
                    notification: state.notification,
                    edited: state.edited,
                    domainAddForm: true,
                    domainEditForm: domainId,
                    loading: state.loading,
                    saving: state.saving
                  };
          }));
  };
  var handleAlert = function (alertType) {
    Curry._1(setState, (function (state) {
            return {
                    notification: alertType,
                    edited: state.edited,
                    domainAddForm: state.domainAddForm,
                    domainEditForm: state.domainEditForm,
                    loading: state.loading,
                    saving: state.saving
                  };
          }));
  };
  var handleReturn = function (param) {
    Curry._1(setState, (function (state) {
            return {
                    notification: state.notification,
                    edited: state.edited,
                    domainAddForm: false,
                    domainEditForm: state.domainEditForm,
                    loading: state.loading,
                    saving: state.saving
                  };
          }));
  };
  var updateOrganization = function (e) {
    e.preventDefault();
    Curry._1(setState, (function (state) {
            return {
                    notification: state.notification,
                    edited: state.edited,
                    domainAddForm: state.domainAddForm,
                    domainEditForm: state.domainEditForm,
                    loading: state.loading,
                    saving: true
                  };
          }));
    var params = {};
    params["organization"] = Organization$ReactHooksTemplate.encode(organizationProfile);
    Js_promise.$$catch((function (param) {
            Curry._1(setState, (function (state) {
                    return {
                            notification: {
                              TAG: "Failure",
                              _0: "Network error. Please try again."
                            },
                            edited: state.edited,
                            domainAddForm: state.domainAddForm,
                            domainEditForm: state.domainEditForm,
                            loading: state.loading,
                            saving: false
                          };
                  }));
            return Promise.resolve();
          }), Js_promise.then_((function (response) {
                var status = Json_decode.field("status", (function (param) {
                        return Json_decode.withDefault("error", Json_decode.string, param);
                      }), response);
                var tmp;
                switch (status) {
                  case "error" :
                      var errorMessage = Json_decode.field("error", Json_decode.string, response);
                      tmp = Curry._1(setState, (function (state) {
                              return {
                                      notification: {
                                        TAG: "Failure",
                                        _0: errorMessage
                                      },
                                      edited: state.edited,
                                      domainAddForm: state.domainAddForm,
                                      domainEditForm: state.domainEditForm,
                                      loading: state.loading,
                                      saving: false
                                    };
                            }));
                      break;
                  case "failure" :
                      tmp = Curry._1(setState, (function (state) {
                              return {
                                      notification: {
                                        TAG: "Failure",
                                        _0: "Invalid settings"
                                      },
                                      edited: state.edited,
                                      domainAddForm: state.domainAddForm,
                                      domainEditForm: state.domainEditForm,
                                      loading: state.loading,
                                      saving: false
                                    };
                            }));
                      break;
                  case "success" :
                      Curry._1(setOrganizationProfile, Json_decode.field("organization", Organization$ReactHooksTemplate.decode, response));
                      tmp = Curry._1(setState, (function (param) {
                              return {
                                      notification: {
                                        TAG: "Success",
                                        _0: "Domain Management Updated"
                                      },
                                      edited: false,
                                      domainAddForm: false,
                                      domainEditForm: undefined,
                                      loading: false,
                                      saving: false
                                    };
                            }));
                      break;
                  default:
                    tmp = Curry._1(setState, (function (state) {
                            return {
                                    notification: {
                                      TAG: "Failure",
                                      _0: "Something went wrong. Please try again later"
                                    },
                                    edited: state.edited,
                                    domainAddForm: state.domainAddForm,
                                    domainEditForm: state.domainEditForm,
                                    loading: state.loading,
                                    saving: false
                                  };
                          }));
                }
                return Promise.resolve(tmp);
              }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/organizations/update", params)));
  };
  var alertType = state.notification;
  var match$2 = state.domainAddForm;
  var match$3 = state.domainEditForm;
  return JsxRuntime.jsxs("div", {
              children: [
                alertType !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                              alertType: alertType,
                              handleClose: (function (param) {
                                  Curry._1(setState, (function (state) {
                                          return {
                                                  notification: undefined,
                                                  edited: state.edited,
                                                  domainAddForm: state.domainAddForm,
                                                  domainEditForm: state.domainEditForm,
                                                  loading: state.loading,
                                                  saving: state.saving
                                                };
                                        }));
                                })
                            }),
                        className: "fixed top-4 right-4 z-50"
                      }) : null,
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("span", {
                                                                children: "🌐",
                                                                className: "text-xl"
                                                              }),
                                                          className: "flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm"
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsx("h1", {
                                                                  children: "Domain Management",
                                                                  className: "text-2xl font-bold text-gray-900"
                                                                }),
                                                            JsxRuntime.jsx("p", {
                                                                  children: "Manage your organization's domains and access settings",
                                                                  className: "text-sm text-gray-600 mt-1"
                                                                })
                                                          ]
                                                        })
                                                  ],
                                                  className: "flex items-center space-x-3"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    state.edited ? JsxRuntime.jsx("span", {
                                                            children: "Unsaved changes",
                                                            className: "inline-flex items-center px-3 py-1 text-xs font-medium text-orange-700 bg-orange-100 rounded-full"
                                                          }) : null,
                                                    JsxRuntime.jsx("button", {
                                                          children: state.saving ? JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    JsxRuntime.jsx("div", {
                                                                          className: "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
                                                                        }),
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "Saving..."
                                                                        })
                                                                  ],
                                                                  className: "flex items-center space-x-2"
                                                                }) : JsxRuntime.jsx("span", {
                                                                  children: "Save Changes"
                                                                }),
                                                          className: "inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 " + (
                                                            state.edited && !state.saving ? "bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500" : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                          ),
                                                          disabled: !state.edited || state.saving,
                                                          onClick: updateOrganization
                                                        })
                                                  ],
                                                  className: "flex items-center space-x-3"
                                                })
                                          ],
                                          className: "flex items-center justify-between"
                                        }),
                                    className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-6 border-b border-gray-200"
                                  }),
                              className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("span", {
                                                      children: "🔐",
                                                      className: "text-lg"
                                                    }),
                                                JsxRuntime.jsx("h2", {
                                                      children: "Primary Domain Access",
                                                      className: "text-lg font-bold text-gray-900"
                                                    })
                                              ],
                                              className: "flex items-center space-x-2"
                                            }),
                                        JsxRuntime.jsx("p", {
                                              children: "Control access to your organization's primary domain",
                                              className: "text-sm text-gray-600 mt-1"
                                            })
                                      ],
                                      className: "bg-gradient-to-r from-green-50 to-emerald-50 px-6 py-4 border-b border-gray-200"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                                          checked: Organization$ReactHooksTemplate.allowPrimaryDomainAccess(organizationProfile),
                                                                          handleChange: (function (param) {
                                                                              Curry._1(setOrganizationProfile, Organization$ReactHooksTemplate.togglePrimaryDomainAccess(organizationProfile));
                                                                              Curry._1(setState, (function (state) {
                                                                                      return {
                                                                                              notification: state.notification,
                                                                                              edited: !state.edited,
                                                                                              domainAddForm: state.domainAddForm,
                                                                                              domainEditForm: state.domainEditForm,
                                                                                              loading: state.loading,
                                                                                              saving: state.saving
                                                                                            };
                                                                                    }));
                                                                            }),
                                                                          labelClassName: "flex items-center"
                                                                        }),
                                                                    JsxRuntime.jsx("span", {
                                                                          children: "Allow Primary Domain Access",
                                                                          className: "text-sm font-medium text-gray-700"
                                                                        })
                                                                  ],
                                                                  className: "flex items-center space-x-2"
                                                                }),
                                                            Organization$ReactHooksTemplate.allowPrimaryDomainAccess(organizationProfile) ? JsxRuntime.jsx("span", {
                                                                    children: "Enabled",
                                                                    className: "inline-flex items-center px-2 py-1 text-xs font-medium text-green-700 bg-green-100 rounded-full"
                                                                  }) : JsxRuntime.jsx("span", {
                                                                    children: "Disabled",
                                                                    className: "inline-flex items-center px-2 py-1 text-xs font-medium text-gray-500 bg-gray-100 rounded-full"
                                                                  })
                                                          ],
                                                          className: "flex items-center space-x-3"
                                                        }),
                                                    JsxRuntime.jsx("p", {
                                                          children: "Enable or disable access to your organization's primary domain",
                                                          className: "text-xs text-gray-500 mt-2"
                                                        })
                                                  ],
                                                  className: "flex-1"
                                                }),
                                            className: "flex items-center justify-between"
                                          }),
                                      className: "p-6"
                                    })
                              ],
                              className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300"
                            }),
                        match$2 ? (
                            match$3 !== undefined ? JsxRuntime.jsx(DomainEdit$ReactHooksTemplate.make, {
                                    domainId: match$3,
                                    handleAlert: handleAlert,
                                    handleReturn: handleReturn
                                  }) : JsxRuntime.jsx(DomainCreate$ReactHooksTemplate.make, {
                                    handleAlert: handleAlert,
                                    handleReturn: handleReturn
                                  })
                          ) : JsxRuntime.jsx(DomainList$ReactHooksTemplate.make, {
                                alertOnDelete: (function (alertType) {
                                    Curry._1(setState, (function (state) {
                                            return {
                                                    notification: alertType,
                                                    edited: state.edited,
                                                    domainAddForm: state.domainAddForm,
                                                    domainEditForm: state.domainEditForm,
                                                    loading: state.loading,
                                                    saving: state.saving
                                                  };
                                          }));
                                  }),
                                handleAddDomain: handleAddDomain,
                                handleEditDomain: handleEditDomain
                              })
                      ],
                      className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
                    })
              ],
              className: "h-full bg-gray-50"
            });
}

var make = DomainManagement;

exports.initialState = initialState;
exports.make = make;
/* react Not a pure module */
